import { Component } from '@angular/core';
import { NavigationService } from 'src/services/navigation/navigation.service';
import { NavigationConfigModel } from 'src/models/navigation/navigation-config.model';
import { AuthenticationService } from 'src/services/authentication/authentication.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
    selector: 'pim-main-navigation',
    templateUrl: './main-navigation.component.html',
    styleUrls: ['./main-navigation.component.sass'],
    standalone: false
})
export class MainNavigationComponent {
	mainNavigationItems$: Observable<NavigationConfigModel[]>;

	constructor(private navigationService: NavigationService,
				private authService: AuthenticationService) {
		// Initialize all main items as collapsed by default
		this.mainNavigationItems$ = this.navigationService.getMainNavigationItems().pipe(
			map((items: NavigationConfigModel[]) => items.map((i: NavigationConfigModel) => ({ ...i, collapsed: true })))
		);
	}

	toggle(item: NavigationConfigModel): void {
		item.collapsed = !item.collapsed;
	}

	logout(): void {
		this.authService.logout();
	}
}
